module.exports = __webpack_public_path__ + "media/media/product-card/software-link-1-ed3454b7bff09b15317ccd44610835c4.png";